// Svelte 5 no longer needs svelte/store imports for basic reactivity

function loadMetricsSettingsFromLocalStorage() {
    let defaults = {
        cpsIncludeSpaces: true, // most platforms include spaces when calculating CPS
        fontSize: 12, // px, applied to the metrics shown on each Event in the Editor List
        visibleMetrics: {
            wpm: true,
            cps: true,
            duration: true,
            words: true,
            chars: true
        },
        summaryBarRate: "cps" // "cps" | "wpm" - drives the Summary reading-rate bar
    };

    let stored = JSON.parse(localStorage.getItem("cc-metrics-settings")) || {};

    let metricsSettings = {
        ...defaults,
        ...stored,
        visibleMetrics: {
            ...defaults.visibleMetrics,
            ...(stored.visibleMetrics || {})
        }
    };

    // Sanitize font size to a sane range
    const parsedFontSize = Number(metricsSettings.fontSize);
    metricsSettings.fontSize = Number.isFinite(parsedFontSize)
        ? Math.min(48, Math.max(6, Math.round(parsedFontSize)))
        : defaults.fontSize;

    metricsSettings.cpsIncludeSpaces = metricsSettings.cpsIncludeSpaces ?? true;
    metricsSettings.summaryBarRate =
        metricsSettings.summaryBarRate === "wpm" ? "wpm" : "cps";

    return metricsSettings;
}

// Create reactive state for metrics settings
export const metricsState = $state(loadMetricsSettingsFromLocalStorage());

// Function to save metrics settings to localStorage
export function saveMetricsSettings() {
    localStorage.setItem("cc-metrics-settings", JSON.stringify(metricsState));
}
